import React from 'react';
import defaultCover from '../assets/novas-banner-template.jpeg';
import { createPortal } from 'react-dom';

export default function LessonPreviewModal({ open, onClose, lesson }) {
  if (!open) return null;
  const docBanners = lesson && typeof lesson.docBanners === 'object' && lesson.docBanners !== null ? Object.values(lesson.docBanners).filter(Boolean) : [];
  const cover = lesson?.cover || lesson?.bannerImage || lesson?.imageUrl || (docBanners.length ? docBanners[0] : defaultCover);
  const title = (lesson?.title && String(lesson.title).trim()) || 'Preview';
  // Build full-page preview URL
  const targetId = lesson && (lesson.originalId || (String(lesson.id || '').startsWith('tmpl-') ? String(lesson.id).slice(5) : lesson.id));
  const qs = lesson && lesson.studentId ? `?studentId=${encodeURIComponent(String(lesson.studentId))}` : '';
  const previewUrl = targetId ? `/lessons/${targetId}/embed${qs}` : '';

  return createPortal(
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 99998, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ width: 720, maxWidth: '95vw', background: '#fff', borderRadius: 12, boxShadow: '0 20px 60px rgba(0,0,0,0.25)', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
        <div style={{ padding: 12, borderBottom: '1px solid #f3f4f6' }}>
          <h2 style={{ margin: 0, fontSize: 18 }}>{title}</h2>
        </div>
        {cover ? <div style={{ height: 120, backgroundImage: `url(${cover})`, backgroundSize: 'cover', backgroundPosition: 'center' }} /> : null}
        <div style={{ height: '60vh' }}>
          {previewUrl ? (
            <iframe
              title="Lesson full preview"
              src={previewUrl}
              style={{ width: '100%', height: '100%', border: 'none' }}
            />
          ) : (
            <div style={{ padding: 16, color: '#6b7280' }}>Preview is unavailable for this item.</div>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}


